import React from "react";
import AppStateScreen from "./AppStateScreen.jsx";
import { MAINTENANCE_MESSAGE } from "../../utils/friendlyErrors.js";
import { recordClientDiagnostic } from "../../utils/clientDiagnostics.js";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    recordClientDiagnostic("request_failed", {
      operation: "ui_render",
      failureCategory: "render_failed",
    });
  }

  handleReload = () => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <AppStateScreen
          title="Maintenance in progress"
          message={MAINTENANCE_MESSAGE}
          tone="error"
          actionLabel="Reload"
          onAction={this.handleReload}
        />
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
